import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { loginRedirectExtras } from '../auth/return-url.util';
import { TokenStorageService } from '../storage/token-storage.service';

/**
 * Use `state.url` (target navigation) — `router.url` can still reflect the previous URL
 * while guards run, which broke `returnUrl` deep links (e.g. `/projects/new`).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const tokens = inject(TokenStorageService);
  const router = inject(Router);

  if (tokens.hasValidTokens()) {
    return true;
  }

  void router.navigate(['/login'], loginRedirectExtras(state.url));
  return false;
};
